<template>
  <div class="playerControlPie" ref="playerControlPie">
    <div class="themeData">
      <span class="echartList">
        <span
          class="echartList_name"
          v-for="item in echartsList"
          :key="item.name"
          v-text="item.name"
        ></span>
      </span>
      <div
        class="echart_dom"
        ref="echartDom_home"
        :style="{ height: `${pHeight}px` }"
      ></div>
    </div>
    <div class="barBox">
      <span class="barBox_title" v-text="'收容情况'"></span>
      <span class="barBox_item" v-for="item in takeInList" :key="item.key">
        <span
          class="barItem_title"
          v-text="`${item.name}: ${item.value}`"
        ></span>
        <span class="barItem_main">
          <span
            class="barItem_actPer"
            :style="{
              width: `${((item.value / item.total) * 100).toFixed(2)}%`,
            }"
          ></span>
          <span class="barItem_bg"></span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
// 数据监控 主题
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'playerControlPie',
  mixins: [canvasToImage_base64_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        title: '',
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      echartsArr: [],
      pHeight: 0,
      echartsList: [],
      takeInList: [],
    }
  },
  watch: {
    datas(val) {
      setTimeout(() => {
        this.initChart(this.$refs.echartDom_home, this.isAutoExportPng)
      }, 10)
    },
  },
  created() {
    this.radarColor = ['rgba(201, 86, 138, 1)', 'rgba(142, 188, 39, 1)']
    console.debug(this.datas)
  },
  mounted() {
    this.$nextTick(() => {
      this.initDomWH()
      setTimeout(() => {
        this.initChart(this.$refs.echartDom_home, this.isAutoExportPng)
      }, 10)
    })
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myEChart) {
      this.myEChart.dispose() //销毁echarts实例，防止内侧泄露
    }
    this.echartsArr = []
  },
  methods: {
    initDomWH() {
      const echartsBoxDom = this.$refs.playerControlPie
      console.debug('playerControlPie:', echartsBoxDom.clientWidth)
      this.pWidth = echartsBoxDom.clientWidth

      this.pHeight = Math.ceil(echartsBoxDom.clientHeight / 2)
      console.debug('this.pWidth:', this.pWidth, this.pHeight)
    },
    initChart(echartRef, isAutoExportPng) {
      const name = 'playerControlPie'
      let result = this.echartsArr.some((val) => {
        if (val.name === name) {
          return true
        }
      })

      console.debug('result', result)

      if (!result) {
        let Echart = this.$echarts.init(echartRef)
        this.echartsArr.push({
          name: name,
          refs: echartRef,
          echarts: Echart,
        })
        setTimeout(() => {
          Echart.resize()
        }, 0)
      }
      // const objectInfo = this.datas.objectInfo
      // const keyArr = this.datas.statisticsModels
      // const maxList = this.datas.data.maxList
      const dataList = this.datas.data.dataList

      let vw = (window.innerWidth || window.screen.availWidth || 1440) / 100
      const item = dataList && dataList[0] ? dataList[0] : {}
      const echartsList = []
      const takeInList = []
      if (item.fm) {
        echartsList.push({
          name: '全马完赛',
          value: item.fmFinish,
          arr: [
            { name: '全马已完成人数 ', value: item.fmFinish },
            { name: '全马参与人数', value: item.fm },
          ],
        })
      }
      if (item.hm) {
        echartsList.push({
          name: '半马完赛',
          value: item.hmFinish,
          arr: [
            { name: '半马已完成人数 ', value: item.hmFinish },
            { name: '半马参与人数', value: item.hm },
          ],
        })
      }
      if (item.mm) {
        echartsList.push({
          name: '迷你马完赛',
          value: item.mmFinish,
          arr: [
            { name: '迷你马已完成人数 ', value: item.mmFinish },
            { name: '迷你马参与人数', value: item.mm },
          ],
        })
      }

      if (item.fmTakeIn || item.fmTakeIn === 0) {
        takeInList.push({
          name: '全马',
          value: item.fmTakeIn,
          key: 'fmTakeIn',
          total: item.fm,
        })
      }
      if (item.hmTakeIn || item.hmTakeIn === 0) {
        takeInList.push({
          name: '半马',
          value: item.hmTakeIn,
          key: 'hmTakeIn',
          total: item.hm,
        })
      }
      if (item.mmTakeIn || item.mmTakeIn === 0) {
        takeInList.push({
          name: '迷你马',
          value: item.mmTakeIn,
          key: 'mmTakeIn',
          total: item.mm,
        })
      }

      this.echartsList = echartsList
      this.takeInList = takeInList

      let options = {
        color: this.radarColor,
        // title: {
        //   show: true,
        //   text: '阅读书籍分布',
        //   left: 'center',
        //   textStyle: {
        //     color: '#999',
        //     fontWeight: 'normal',
        //     fontSize: 14,
        //   },
        // },
        // tooltip: {
        //   trigger: 'item',
        // },
        series: echartsList.map((item, idx) => {
          let per = 50
          if (echartsList.length == 3) {
            per = 33.3
          }
          let left = idx * per
          return {
            type: 'pie',
            radius: ['40%', '70%'],
            top: '10%',
            height: `${this.pHeight}px`,
            left: `${left}%`,
            width: `${per}%`,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1,
            },
            label: {
              show: true,
              position: 'center',
              formatter: `${item.value}`,
              fontWeight: 'bold',
              fontSize: Math.ceil(0.972 * vw),
            },
            labelLine: {
              show: false,
            },
            data: item.arr,
          }
        }),
      }
      this.echartsArr.forEach((val, index) => {
        if (val.name === name) {
          console.debug('val.name:', val.name, 'name', name)
          val.echarts.setOption(options)
        }
      })
      //   console.debug('emitEventName:', isAutoExportPng)
      //   if (isAutoExportPng) {
      //     setTimeout(() => {
      //       this.upLoad(echartRef, true, 'uploadData')
      //     }, 500)
      //   }
    },
  },
}
</script>

<style lang="scss" scoped>
.playerControlPie {
  position: relative;
  width: 100%;
  height: 16.936vw;
  padding: 0 3%;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  .themeData {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .echartList {
      position: absolute;
      top: 0;
      left: 5%;
      width: 90%;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: space-evenly;
      align-items: center;
      .echartList_name {
        flex: 1;
        text-align: center;
        font-size: 0.972vw;
        line-height: 2.083vw;
      }
    }
    .echart_dom {
      width: 90%;
    }
  }
  .barBox {
    width: 100%;
    height: auto;
    color: var(--mixtmt_greyColor3);
    .barBox_title {
      display: block;
      font-size: 1.11vw;
      line-height: 2.083vw;
      font-weight: bold;
    }
    .barBox_item {
      padding-top: 0.694vw;
      display: block;
      width: 100%;
      height: auto;
      & > span {
        display: block;
      }
    }
    .barItem_title {
      width: 100%;
      font-size: 0.833vw;
      line-height: 1.11vw;
    }
    .barItem_main {
      position: relative;
      width: 100%;
      & > span {
        display: block;
      }
      .barItem_actPer {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        /* width: 60%; */
        height: 100%;
        border-radius: 2.083vw;
        background: linear-gradient(-90deg, #94be21 0%, #5aac62 100%);
      }
      .barItem_bg {
        width: 100%;
        height: 0.416vw;
        border-radius: 2.083vw;
        background-color: var(--mixtmt_greyColor0);
      }
    }
  }
}
.mixtmt_ipad .playerControlPie {
  padding: 0 2%;
  .themeData {
    .echart_dom {
      width: 85%;
    }
  }
}
</style>
